/**
 * Copyright 2020 New Light Technologies, Inc.
 *
 * With Supporting Sponsorship from the Federal Emergency Management Agency (Contract: GSA Stars II GS-06F-0968Z)
 * In accordance with FAR 52.227-14(c)(iii), New Light Technologies, Inc. grants to the Government and others acting on its behalf a paid-up, nonexclusive, irrevocable, worldwide license in such copyrighted computer software and data to reproduce, prepare derivative works, and perform publicly and display publicly (but not to distribute copies to the public) by or on behalf of the Government.
 * Any other use, distribution, reproduction, modification, or publication without the prior express written authorization of New Light Technologies, Inc. is strictly prohibited.
 * All other rights are reserved by their respective copyright holders.
 *
 */
import { Box } from '@mui/material';

export const Footer = () => {
  return (
    <Box
      sx={{
        color: 'white',
        width: '100%',
        backgroundColor: 'rgb(0, 62, 103)',
        padding: '0.5rem 1.25rem',
        position: 'relative',
        fontWeight: 'bold',
        lineHeight: '1.1',
        fontSize: '1.1rem',
        zIndex: 1300,

        '& a': {
          color: 'white',
          '&:visited': {
            color: 'white',
          },
        },
      }}
    >
      Powered by{' '}
      <a target="_blank" rel="noreferrer" href="https://newlighttechnologies.com/impact">
        New Light Technologies (NLT) IMPACT Platform
      </a>
    </Box>
  );
};
